import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IFrame } from 'src/components/ui/GlobalComponents/IFrame/IFrame';
import useUser from 'src/hook/data/useUser';
import { useGlobalMessageListener } from 'src/hook/global/useGlobalMessageListener';
import { IFrameMessage } from 'src/model/enum/enums';
import { GetRazorSiteUrl } from 'src/utils/URLUtils';
import styles from './Comparison.module.scss';

export const Comparison = () => {
    const { t } = useTranslation();
    const { userInfo } = useUser();
    const navigate = useNavigate();

    const handleMessage = useCallback((event: MessageEvent) => {
        if (event.data.type === IFrameMessage.NavigationToDomain) {
            var url = event.data.url;
            navigate(`/${url}`);
        }
    }, [navigate]);


    useGlobalMessageListener(handleMessage, [IFrameMessage.NavigationToDomain]);

    return (
        <div className={styles.comparison}>
            {/* <PageHeader title={t('12 Reasons to join')} /> */}
            <IFrame
                src={GetRazorSiteUrl('pro/subscription-comparison', userInfo?.Token)}
            />
        </div>
    );
}; 